import { ChargepointUptimeDay, ConnectorUptimeSummary } from 'types/swagger';

import { TimeSpentByPeriod } from '../interfaces';

export const uptimeDataMock: ChargepointUptimeDay[] = [];

for (let i = 1; i <= 1440; i++) {
  const currentTime = new Date('2023-09-13T00:00:00');
  currentTime.setMinutes(currentTime.getMinutes() + i);

  const online = Math.random() < 0.99;

  uptimeDataMock.push({
    current_time: currentTime.toISOString(),
    online: online,
  });
}

export const timezone = 'America/Santiago';
export const uptimePercentage = 99;
export const uptimeSummary: ConnectorUptimeSummary = {
  Idle: '40',
  Charging: '55',
  Faulted: '4',
  Offline: '1',
};
export const timeSpent: TimeSpentByPeriod = {
  Idle: { minutes: 576, hours: 67 },
  Charging: { minutes: 792, hours: 92 },
  Faulted: { minutes: 58, hours: 7 },
  Offline: { minutes: 14, hours: 2 },
};
